export default __webpack_public_path__ + "static/me-6adc84fd9cdb3d6881fb4debbc44cfc6.jpg";